export enum ROUTES {
  /* Main */
  HOME = '/',

  /* Policy */
  POLICY_LIST = '/policy',
  POLICY_DETAIL = '/policy/:uuid',

  /* Billing */
  BILLING_LIST = '/billing',

  /* Auth */
  LOGIN = '/login',

  /* Renewal Prioritizer */
  RENEWAL_PRIORITIZER = '/renewal-prioritizer',
}
